import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import KillDiabetes from './pages/KillDiabetes';
import OurCenters from './pages/OurCenters';
import CenterDetail from './pages/CenterDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/kill-diabetes" element={<KillDiabetes />} />
        <Route path="/our-centers" element={<OurCenters />} />
        <Route path="/center/:id" element={<CenterDetail />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;